import Alerts from "./alerts";
import Bar from "./system-messages-bar";
import Prompts from "./prompts";

export default function (parentModule: string): string {
    const moduleName = `${parentModule}.components`;

    return angular
        .module(moduleName, [Alerts(moduleName), Bar(moduleName), Prompts(moduleName)])
        .name;
}
